export class LazyLoadVideo {
    constructor() {
        const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));
        if (lazyVideos.length > 0) {
            if ('IntersectionObserver' in window) {
                const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
                    entries.forEach(function (video) {
                        if (video.isIntersecting) {
                            for (const source in video.target.children) {
                                const videoSource = video.target.children[source];
                                if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                    // @ts-ignore
                                    videoSource.src = videoSource.dataset.src;
                                }
                            }
                            // @ts-ignore
                            video.target.load();
                            // @ts-ignore
                            video.target.play();
                            console.log('vid', video);
                            video.target.classList.remove('lazy');
                            lazyVideoObserver.unobserve(video.target);
                        }
                    });
                });
                lazyVideos.forEach(function (lazyVideo) {
                    lazyVideoObserver.observe(lazyVideo);
                });
            }
        }
    }
}
